import dids from './dids';
import tendlc from './tendlc';
import history from './history';
import finance from './finance';
import campaign from './campaign';
import processes from './processes';

const combineSaga = {
  ...campaign,
  ...dids,
  ...tendlc,
  ...history,
  ...finance,
  ...processes,
};

export default combineSaga;
